import { NarratorId } from '../narrator/narrator.model';
import { POISpotlight } from '../spotlight/spotlight.model';

export const POI_ACTIVE_CLASS = 'is-active';
export const MAP_READY_CLASS = 'is-ready';

export type POI_ID = string;
export type MapID = string;

export type MapConfig = {
  id: MapID;
  imagePath: string;
  size: [number, number];
  backgroundColor?: string;
};

export type Portal = {
  targetMap: MapID;
  targetPOI: POI_ID;
};

export type POI = {
  id: POI_ID;
  mapId: MapID;
  spotlight?: POISpotlight;
  destination: Destination;
  narratorId?: NarratorId;
  pos: [number, number];
  portal?: Portal;
};

export type Destination = POI_ID[];

export enum NavigatorEventBus {
  navigationEnd = 'navigationEnd',
  navigationStart = 'navigationStart',
  mapChanged = 'mapChanged',
}

export const TravelTime = 1000;
